import React, { useState, useEffect } from "react";
import { Card } from "@material-ui/core";
import {
  CircularProgress,
  Typography,
  Button,
  TextField,
} from "@material-ui/core";
import useStyles from "../login/styles";
import { activate } from "../../services/user.service";
import SnackbarAlert from "../../shared/Snackbar";
import { withRouter } from "react-router-dom";
import Notify from "../../shared/Notify";
import { NotifyModel } from "../../models/Auth.model";
const UserActivate = (props) => {
  const classes = useStyles();
  var [isLoading, setIsLoading] = useState(false);
  var [userData, setUserData] = useState({
    loginValue: "",
    passwordValue: "",
  });
  var [error, setError] = useState(false);
  var [erroText, setErroText] = useState(false);
  const [limitError, setLimitError] = useState({});

  const [notifyProps, setNotifyProps] = useState(NotifyModel);

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
    message: "",
  });
  useEffect(() => {
    localStorage.clear();
  }, []);
  let newState = { vertical: "bottom", horizontal: "center" };
  const { vertical, horizontal, open, message } = state;
  const reset = () => {
    let data = {
      password: userData.passwordValue,
      token: sessionStorage.getItem("ACTIVATE_TOKEN"),
    };
    if (handleValidation(userData)) {
      save(data);
    } else {
    }
  };
  function save(data) {
    setIsLoading(true);
    activate(data).then(
      (response) => {
        setIsLoading(false);
        if (response.data.statusCode === 200) {
          setNotifyProps({
            ...notifyProps,
            message: response.data.message,
            type: "success",
            toggle: true,
          });
          setTimeout(() => {
            props.history.push("/login");
          }, 2000);
        } else {
          setNotifyProps({
            ...notifyProps,
            message: response.data.message,
            type: "error",
            toggle: true,
          });
        }
      },
      (error) => {
        setNotifyProps({
          ...notifyProps,
          message: "Something Went Wrong",
          type: "error",
          toggle: true,
        });
      },
    );
  }
  function handleValidation(fields) {
    let data = fields;
    let err = {};
    let formIsValid = true;
    if (data["loginValue"].length < 6) {
      formIsValid = false;
      err["loginValue"] =
        "Password must be of minimum 6 characters and maximum 20 characters.";
    }
    if (data["loginValue"].length > 20) {
      formIsValid = false;
      err["loginValue"] =
        "Password must be of minimum 6 characters and maximum 20 characters.";
    }
    if (data["loginValue"] !== data["passwordValue"]) {
      formIsValid = false;
      err["passwordValue"] = "Password not match";
    }
    setLimitError(err);
    return formIsValid;
  }
  const handleChange = (e) => {
    e.persist();
    let value = e.target.value;
    setUserData({
      ...userData,
      [e.target.name]: value,
    });
  };
  return (
    <div className="row container">
      <div className={`col-md-4 offset-md-5 ${classes.containerPostion}`}>
        <Card className={classes.resetCard}>
          <React.Fragment>
            <Typography variant="h5" className={classes.greeting}>
              Activate User
            </Typography>
            <TextField
              error={error}
              id="newpassword"
              classes={{
                root: classes.editableInput,
              }}
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
              value={userData.loginValue}
              onChange={handleChange}
              margin="normal"
              label="New Password"
              type="password"
              name="loginValue"
              fullWidth
              helperText={
                limitError && limitError.loginValue
                  ? limitError.loginValue
                  : null
              }
            />
            <TextField
              error={error}
              id="confirmpassword"
              classes={{
                root: classes.editableInput,
              }}
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
              value={userData.passwordValue}
              onChange={handleChange}
              margin="normal"
              label="Confirm Password"
              type="password"
              name="passwordValue"
              fullWidth
              helperText={
                limitError && limitError.passwordValue
                  ? limitError.passwordValue
                  : null
              }
            />

            <div className={classes.formButtons}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                className={classes.loginButton}
                onClick={() => reset()}
                disabled={isLoading}
              >
                {" "}
                {!isLoading ? (
                  <span>Submit</span>
                ) : (
                  <span>
                    <CircularProgress color="default" size={20} />
                  </span>
                )}
              </Button>
            </div>
          </React.Fragment>
        </Card>
      </div>
      <Notify notifyProps={notifyProps} />
    </div>
  );
};

export default withRouter(UserActivate);
